<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-date-picker v-model="servetime" type="datetimerange" :picker-options="pickerOptions"
                    range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" align="left"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']" @change="dateChange"></el-date-picker>
            </el-form-item>
            <el-form-item class="query-form-item" label="订单状态">
                <el-select v-model="query.orderstatus" placeholder="请选择" @change="onSubmit" clearable>
                    <el-option label="全部" value="-1"></el-option>
                    <el-option label="待支付" value="0"></el-option>
                    <el-option label="已排产" value="1"></el-option>
                    <el-option label="生产中" value="2"></el-option>
                    <el-option label="包装中" value="3"></el-option>
                    <el-option label="待发货" value="4"></el-option>
                    <el-option label="待收货" value="5"></el-option>
                    <el-option label="已完成" value="6"></el-option>
                    <el-option label="已取消" value="7"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item" label="发货类型">
                <el-select v-model="query.orderphysicaltype" placeholder="请选择" @change="onSubmit" clearable>
                    <el-option label="全部" value="-1"></el-option>
                    <el-option label="自提" value="3"></el-option>
                    <el-option label="DHL物流" value="2"></el-option>
                    <el-option label="联邦快递" value="1"></el-option>
                    <el-option label="HFM物流" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item" label="专属客服">
                <el-select v-model="query.serveid" placeholder="请选择客服" style="width:150px" @change="onSubmit" clearable>
                    <el-option label="全部" value="-1"></el-option>
                    <el-option v-for="(item, index) in userList" :key="index" :label="item.compellation"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-input placeholder="订单号" v-model="query.systemtradeno" prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                <el-button type="primary" icon="el-icon-download" size="small" @click="exportExcel()">导出</el-button>
            </el-form-item>
        </el-form>
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
            border>
            <el-table-column label="订单号" align="center" width="200" prop="systemtradeno" />
            <el-table-column label="专属客服" align="center" width="100" prop="compellation" />
            <el-table-column label="发货仓" align="center" width="100" prop="repertorysname" />
            <el-table-column label="实付金额" align="center" width="100">
                <template slot-scope="scope">
                    <span>
                        ${{
            scope.row.ordertotalprice | price(scope.row.ordertotalprice)
            }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="付款方式" align="center" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.orderpaytype == null">-</span>
                    <span v-if="scope.row.orderpaytype == 0">PayPal</span>
                    <span v-if="scope.row.orderpaytype == 1">支付宝</span>
                    <span v-if="scope.row.orderpaytype == 2">线下支付</span>
                    <span v-if="scope.row.orderpaytype == 5">凭证支付</span>
                    <span v-if="scope.row.orderpaytype == 3">
                        账期额度
                        <el-button v-if="scope.row.orderpaytype == 3 && scope.row.orderotherstatus == 0" type="primary"
                            size="mini" @click.native="returnLine(scope.row)">归还额度</el-button>
                        <el-button v-if="scope.row.orderpaytype == 3 && scope.row.orderotherstatus == 1" type="primary"
                            size="mini" @click.native="returnLine(scope.row)" disabled>已归还</el-button>
                    </span>
                    <span v-if="scope.row.orderpaytype == 4">稍后付款</span>
                </template>
            </el-table-column>
            <el-table-column label="积分抵扣" align="center" width="100" prop="orderintegral">
                <template slot-scope="scope">
                    <span v-if="scope.row.playintegral == 0">-</span>
                    <span v-if="scope.row.playintegral == 1">{{scope.row.orderintegral}}</span>
                </template>
            </el-table-column>
            <el-table-column label="快递方式" align="center" width="100" prop="orderphysicaltype">
                <template slot-scope="scope">
                    <!-- <span v-if="scope.row.orderfreight != null">{{
            scope.row.expressname
          }}</span>
          <span v-else>自提</span>-->
                    <span v-if="scope.row.orderphysicaltype == 0">HFM物流</span>
                    <span v-if="scope.row.orderphysicaltype == 1">联邦快递</span>
                    <span v-if="scope.row.orderphysicaltype == 2">DHL物流</span>
                    <span v-if="scope.row.orderphysicaltype == 3">自提</span>
                    <span v-if="scope.row.orderphysicaltype == null">-</span>
                </template>
            </el-table-column>
            <el-table-column label="货期" align="center" width="100" prop="specsurvi" />
            <el-table-column label="下单时间" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span v-if="scope.row.ordertime != null">
                        {{scope.row.ordertime | formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="订单状态" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.orderstatus == 0">待支付</span>
                    <span v-if="scope.row.orderstatus == 1">已排产</span>
                    <span v-if="scope.row.orderstatus == 2">生产中</span>
                    <span v-if="scope.row.orderstatus == 3">包装中</span>
                    <span v-if="scope.row.orderstatus == 4">待发货</span>
                    <span v-if="scope.row.orderstatus == 5">待收货</span>
                    <span v-if="scope.row.orderstatus == 6">已完成</span>
                    <span v-if="scope.row.orderstatus == 7">已取消</span>
                    <span v-if="scope.row.orderstatus == 8">已申请售后</span>
                    <span v-if="scope.row.orderotherstatus == 1 ">(账期额度已归还)</span>
                </template>
            </el-table-column>
            <el-table-column width="300" label="操作" align="left">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.native="handleInfo(scope.$index, scope.row)">查看
                    </el-button>
                    <el-button v-if="scope.row.orderstatus == 0" type="primary" size="mini"
                        @click.native="cancleOrder(scope.row)">取消订单</el-button>
                    <el-button v-if="
              scope.row.orderstatus == 1 ||
                scope.row.orderstatus == 2 ||
                scope.row.orderstatus == 3
            " type="primary" size="mini" @click.native="nextStept(scope.row)">下一步</el-button>
                    <el-button v-if="scope.row.orderstatus == 4" type="primary" size="mini"
                        @click.native="send(scope.row)">发货</el-button>
                    <el-button v-if="scope.row.orderstatus == 5" type="primary" size="mini"
                        v-show="scope.row.orderphysicaltype == 1" @click.native="expressMessage(scope.row)">物流
                    </el-button>
                    <el-button v-if="scope.row.orderstatus == 5" type="primary" size="mini"
                        v-show="scope.row.orderphysicaltype == 2" @click.native="expressMessage(scope.row)">物流
                    </el-button>
                    <!-- <el-button
            v-if="scope.row.orderstatus == 5"
            type="primary"
            size="mini"
            v-show="scope.row.orderphysicaltype==3 | scope.row.orderphysicaltype==0"
            @click.native="expressMessagess()"
          >物流</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pagination-container" background :page-size="query.pageSize"
            :current-page="query.currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>
        <!-- <el-button type="primary" style="margin-top: 10px;">同步逍客</el-button> -->
        <!--  物流 --->
        <el-dialog title="物流信息" :visible.sync="formExpress" :before-close="hideExpress" width="800px" top="5vh"
            v-dialogDrag>
            <el-form :model="this.expressInfo">
                <el-form-item label="快递公司:">
                    <div v-if="this.expressInfo.trackingName != null" v-html="this.expressInfo.trackingName" readonly />
                </el-form-item>
                <el-form-item label="快递单号:">
                    <div v-if="this.expressInfo.trackingNumber != null" v-html="this.expressInfo.trackingNumber"
                        readonly />
                </el-form-item>
                <el-form-item label="快件跟踪：" />
                <div class="block">
                    <el-timeline>
                        <el-timeline-item v-for="(items, index) in this.expressInfo.events" :key="index"
                            icon="el-icon-more" color="#0bbd87">
                            <span v-if="items.address.city!=null">{{ items.address.countryCode +
                ' ' +
                items.address.city +
                '   ' +
                items.eventDescription}}</span>
                            <span v-else>{{items.eventDescription}}</span>
                            <!-- {{items.eventDescription}} -->

                            <!-- {{ items.address.countryCode +
                ' ' +
                items.address.city +
                '   ' +
                items.eventDescription}} -->
                            <br>
                            <br>
                            {{items.timestamp |formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </el-form>
        </el-dialog>



        <el-dialog title="物流信息" :visible.sync="formExpresss" :before-close="hideExpresss" width="800px" top="5vh"
            v-dialogDrag>
            <el-form :model="this.expressInfos">
                <el-form-item label="快递公司:">
                    <input :value="'DHL'" readonly>
                </el-form-item>
                <el-form-item label="快递单号:">
                    <input v-if="this.expressInfos.awbnumber != null" :value="this.expressInfos.awbnumber" readonly>
                </el-form-item>
                <el-form-item label="快件跟踪：" />
                <div class="block">
                    <el-timeline :reverse="'false'">
                        <el-timeline-item v-for="(items, index) in this.expressInfos.shipmentInfo.shipmentEvent
            .logistics" :key="index" icon="el-icon-more" color="#0bbd87" :timestamp="items.date + ' ' + items.time">

                            {{items.serviceEvent.description}}
                        </el-timeline-item>
                    </el-timeline>
                </div>
                <!-- <div
          v-for="(items, index) in this.expressInfos.shipmentInfo.shipmentEvent
            .logistics"
          :key="index"
        >
          <input :value="'第' + [index + 1] + '条:'">
          <br>
          <br>
          <input
            :value="
              items.serviceEvent.description
            "
            readonly
          >
          <el-form-item>
            <input :value="items.date + ' ' + items.time">
          </el-form-item>
        </div> -->
            </el-form>
        </el-dialog>

        <el-dialog :visible.sync="formInfo" :before-close="hideInfo" width="1200px" top="5vh" v-dialogDrag title="订单详情">
            <br>
            <el-form ref="dataForm" v-if="orderinfo.mbOrderVO">
                <div style="display: flex;justify-content: space-between;">
                    <h2>订单信息:</h2>
                    <el-button type="primary" icon="el-icon-download" size="small"
                        @click="exportOrderDetailExcel(orderinfo.mbOrderVO)">导出</el-button>
                </div>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="订单系统号:" style="width:50%;display: inline-block">
                        <span>{{orderinfo.mbOrderVO.orderid}}</span>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="订单编号:" style="width:50%;display: inline-block">
                        <input v-model="orderinfo.mbOrderVO.systemtradeno" type="text" readonly>
                    </el-form-item>
                    <el-form-item label="订单状态:" style="width:30%;display: inline-block;margin-left:0px;">
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 0">待支付</span>
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 1">已排产</span>
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 2">生产中</span>
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 3">包装中</span>
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 4">待发货</span>
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 5">待收货</span>
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 6">已完成</span>
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 7">已取消</span>
                        <span v-if="orderinfo.mbOrderVO.orderstatus == 8">已申请售后</span>
                        <span v-if="orderinfo.mbOrderVO.orderotherstatus == 1">(账期额度已归还)</span>
                        &nbsp;&nbsp;

                        <el-button v-if="orderinfo.mbOrderVO.orderstatus == 0" type="primary" size="mini"
                            @click.native="cancleOrder(orderinfo.mbOrderVO)">取消订单</el-button>&nbsp;
                        <el-button type="primary" size="mini" @click="editState()">修改</el-button>
                        <!-- <el-button
              v-if="orderinfo.mbOrderVO.orderstatus == 5"
              type="primary"
              size="mini"
              @click.native="expressMessage(orderinfo.mbOrderVO)"
              >物流</el-button
            >-->
                        <el-button v-if="orderinfo.mbOrderVO.orderstatus == 5" type="primary" size="mini"
                            v-show="orderinfo.mbOrderVO.orderphysicaltype == 1"
                            @click.native="expressMessage(orderinfo.mbOrderVO)">物流</el-button>
                        <el-button v-if="orderinfo.mbOrderVO.orderstatus == 5" type="primary" size="mini"
                            v-show="orderinfo.mbOrderVO.orderphysicaltype == 2"
                            @click.native="expressMessage(orderinfo.mbOrderVO)">物流</el-button>
                        <!-- <el-button
            v-if="orderinfo.mbOrderVO.orderstatus == 5"
            type="primary"
            size="mini"
            v-show="orderinfo.mbOrderVO.orderphysicaltype==3 |orderinfo.mbOrderVO.orderphysicaltype==0"
            @click.native="expressMessagess()"
            >物流</el-button>-->
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="下单时间:" style="width:50%;display: inline-block">
                        <span v-if="orderinfo.mbOrderVO.ordertime == null">无</span>
                        <span v-if="orderinfo.mbOrderVO.ordertime != null">
                            {{orderinfo.mbOrderVO.ordertime| formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                        </span>
                    </el-form-item>
                    <el-form-item label="付款时间:" style="width:30%;display: inline-block;margin-left:0px;">
                        <span v-if="orderinfo.mbOrderVO.orderpaytime == null">无</span>
                        <span v-if="orderinfo.mbOrderVO.orderpaytime != null">
                            {{orderinfo.mbOrderVO.orderpaytime| formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                        </span>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="排产时间:" style="width:50%;display: inline-block">
                        <span v-if="orderinfo.mbOrderVO.orderschedulingtime == null">无</span>
                        <span v-if="orderinfo.mbOrderVO.orderschedulingtime != null">
                            {{orderinfo.mbOrderVO.orderschedulingtime| formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                        </span>
                    </el-form-item>
                    <el-form-item label="生产时间:" style="width:30%;display: inline-block;margin-left:0px;">
                        <span v-if="orderinfo.mbOrderVO.orderprodutime == null">无</span>
                        <span v-if="orderinfo.mbOrderVO.orderprodutime != null">
                            {{orderinfo.mbOrderVO.orderprodutime| formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                        </span>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="包装时间:" style="width:50%;display: inline-block">
                        <span v-if="orderinfo.mbOrderVO.orderpacktime == null">无</span>
                        <span v-if="orderinfo.mbOrderVO.orderpacktime != null">
                            {{orderinfo.mbOrderVO.orderpacktime| formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                        </span>
                    </el-form-item>
                    <el-form-item label="发货时间:" style="width:50%;display: inline-block;margin-left:0px;">
                        <span v-if="orderinfo.mbOrderVO.orderdevlitime == null">无</span>
                        <span v-if="orderinfo.mbOrderVO.orderdevlitime != null">
                            {{orderinfo.mbOrderVO.orderdevlitime| formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                        </span>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="收货时间:" style="width:50%;display: inline-block">
                        <span v-if="orderinfo.mbOrderVO.ordertacktime == null">无</span>
                        <span v-if="orderinfo.mbOrderVO.ordertacktime">
                            {{orderinfo.mbOrderVO.ordertacktime| formatDateStr("yyyy-MM-dd hh:mm:ss")}}
                        </span>
                    </el-form-item>
                    <el-form-item label="发货仓:" style="width:40%;display: inline-block;margin-left:0px;">
                        <input v-if="orderinfo.mbOrderVO.repertorysname == null" value="-" type="text" readonly>
                        <input v-if="orderinfo.mbOrderVO.repertorysname != null"
                            :value="orderinfo.mbOrderVO.repertorysname" type="text" readonly>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="承运公司:" prop="expressname" style="width:50%;display: inline-block">
                        <!--<span v-if="orderinfo.mbOrderVO.expressname"></span>-->
                        <input v-model="orderinfo.mbOrderVO.expressname" type="text" readonly>
                        <el-button type="primary" size="mini" @click="editLogistics()">修改</el-button>
                    </el-form-item>
                    <el-form-item label="运单码/运单编号:" style="width:30%;display: inline-block;margin-left:0px;">
                        <span>
                            {{orderinfo.mbOrderVO.expressnum}}
                        </span>
                        <el-button size="mini" type="primary" @click="editOdd()">修改</el-button>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="快递方式:" style="width:50%;display: inline-block">
                        <!-- <span v-if="orderinfo.mbOrderVO.orderfreight != null">{{
              orderinfo.mbOrderVO.expressname
            }}</span>
            <span v-else>自提</span>-->
                        <span>{{orderinfo.mbOrderVO.orderphysicaltype | orderphysicaltypeFilter}}</span>
                    </el-form-item>

                    <el-form-item label="运费:" style="width:30%;display: inline-block;margin-left:0px;">
                        <span>
                            {{
              orderinfo.mbOrderVO.orderfreight
              | price(orderinfo.mbOrderVO.orderfreight)
              }}（美元）
                        </span>
                        <el-button size="mini" type="primary" @click="editFreight()">修改</el-button>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="实付金额:" style="width:50%;display: inline-block">
                        <span>
                            ${{
              orderinfo.mbOrderVO.ordertotalprice
              | price(orderinfo.mbOrderVO.ordertotalprice)
              }}
                        </span>
                        <el-button size="mini" type="primary" @click="editPrice()"
                            :disabled="orderinfo.mbOrderVO.orderstatus != 0">
                            修改金额</el-button>
                    </el-form-item>
                    <el-form-item label="积分抵扣:" style="width:50%;display: inline-block;margin-left:0px;">
                        <span v-if="orderinfo.mbOrderVO.playintegral==1">{{orderinfo.mbOrderVO.orderintegral}}</span>
                        <span v-if="orderinfo.mbOrderVO.playintegral==0">未使用积分</span>
                        <!-- <input v-model="orderinfo.mbOrderVO.orderintegral" type="text" readonly> -->
                    </el-form-item>
                </el-form-item>
                <!-- <el-form-item label="支付凭证:" style="width:30%;display: inline-block">
          <input v-if="orderinfo.mbOrderVO.playorder==null" value="无">
          <el-popover placement="right" trigger="hover" v-if="orderinfo.mbOrderVO.playorder!=null">
            <img :src="orderinfo.mbOrderVO.playorder" style="width:400px;border-radius:3px;">
            <img
              slot="reference"
              :src="orderinfo.mbOrderVO.playorder"
              style="max-height: 50px;max-width: 50px;border-radius:5px;"
            >
          </el-popover>
        </el-form-item> -->
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="货期:" style="width:50%;display: inline-block">
                        <input v-if="orderinfo.mbOrderVO.specsurvi" type="text" :value="orderinfo.mbOrderVO.specsurvi"
                            readonly>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="订单处理员:" style="width:50%;display: inline-block">
                        <input v-if="orderinfo.mbOrderVO.compellation" :value="orderinfo.mbOrderVO.compellation"
                            type="text" readonly>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="备注信息:" style="width:50%;display: inline-block">
                        <input v-if="orderinfo.mbOrderVO.orderleave" :value="orderinfo.mbOrderVO.orderleave" type="text"
                            readonly>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px" v-if="orderinfo.mbOrderVO.playorder">
                    <el-form-item label="支付凭证:" style="width:50%;display: inline-block">
                        <template v-if="orderinfo.mbOrderVO.playorder.toLowerCase().indexOf('pdf')>-1" >
                            <a :href="orderinfo.mbOrderVO.playorder" target="_blank">打开pdf凭证</a>
                        </template>
                        <el-popover v-else placement="right" trigger="hover">
                            <img :src="orderinfo.mbOrderVO.playorder" style=";max-width: 300px;border-radius:5px;">
                            <img slot="reference" :src="orderinfo.mbOrderVO.playorder" class="playorder"/>
                        </el-popover>
                    </el-form-item>
                </el-form-item>

                <el-table ref="multipleTable" v-loading="loading" :data="orderinfo.mbOrderComVOList"
                    :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
                    @selection-change="handleSelectionChange" border>
                    <el-table-column label="产品编码" align="center" prop="productnum" />
                    <el-table-column label="图片" prop="commodityurl" align="center" width="200">
                        <template slot-scope="scope">
                            <el-popover placement="right" trigger="hover">
                                <img :src="scope.row.commodityurl" style="width:400px;border-radius:3px;">
                                <img slot="reference" :src="scope.row.commodityurl"
                                    style="max-height: 50px;max-width: 50px;border-radius:5px;">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品名称" align="center" prop="commodityname" show-overflow-tooltip />
                    <el-table-column label="货期" prop="specsurvi" align="center" />
                    <el-table-column label="重量" prop="speclweight" align="center" />
                    <el-table-column label="材质规格" align="center" prop="specstands" />
                    <el-table-column label="单价" align="center" prop="commodityprice" />
                    <el-table-column label="数量" align="center" prop="commoditynum" />
                    <el-table-column label="单品合计" align="center" prop="totalprice" />
                </el-table>
                <el-form-item label="留言:">
                    <input v-model="orderinfo.mbOrderVO.orderleave" type="text" readonly>
                </el-form-item>

                <h2>买家信息:</h2>
                <br>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="用户邮箱:" style="width:50%;display: inline-block">
                        <input v-if="orderinfo.mbUserAddressVO != null" :value="orderinfo.mbUserAddressVO.useremail"
                            type="text" readonly>
                        <input v-if="orderinfo.mbUserAddressVO == null" value="-" type="text" readonly>
                    </el-form-item>

                    <el-form-item label="取货方式:" style="width:30%;display: inline-block">
                        <input v-if="orderinfo.mbOrderVO.orderphysicaltype == null" value="-">
                        <input v-if="orderinfo.mbOrderVO.orderphysicaltype == 0" value="HFM物流">
                        <input v-if="orderinfo.mbOrderVO.orderphysicaltype == 1" value="联邦快递">
                        <input v-if="orderinfo.mbOrderVO.orderphysicaltype == 2" value="DHL物流">
                        <input v-if="orderinfo.mbOrderVO.orderphysicaltype == 3" value="自提">
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="收货人:" style="width:50%;display: inline-block">
                        <input v-if="orderinfo.mbUserAddressVO != null"
                            :value="orderinfo.mbUserAddressVO.useraddressname" type="text" readonly>
                        <input v-if="orderinfo.mbUserAddressVO == null" value="-" type="text" readonly>
                    </el-form-item>
                    <el-form-item label="联系方式:" style="width:30%;display: inline-block">
                        <input v-if="orderinfo.mbUserAddressVO != null"
                            :value="orderinfo.mbUserAddressVO.useraddressphone" type="text" readonly>
                        <input v-if="orderinfo.mbUserAddressVO == null" value="-" type="text" readonly>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="收货地址:">
                    <div v-if="orderinfo.mbUserAddressVO != null" v-html="orderinfo.mbUserAddressVO.useraddress" />
                    <div v-if="orderinfo.mbUserAddressVO == null">-</div>
                </el-form-item>

                <h2>附件信息:</h2>
                <br>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px" v-model="priceList">
                    <el-form-item label="发货图片:" style="width:50%;display: inline-block">
                        <el-upload v-show="pic_is_show" class="avatar-uploader" style="margin-bottom: 15px;"
                            accept=".png, .jpg, .gif, .jpeg, .bmp" :action="uploadUrl" :headers="{
                            hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'
                        }" :show-file-list="false" :on-success="handleAvatarSuccess">
                            <img v-if="orderinfo.mbOrderVO.sendurl" :src="orderinfo.mbOrderVO.sendurl" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="技术附件:" style="width:100%;">
                        <!-- <div style="display:flex;justify-content: center;flex-direction: column;">
                            <p>2021.8.21 &nbsp;<el-button type="text" size="mini">查看</el-button>
                            </p>
                            <p>2021.8.21 &nbsp;<el-button type="text" size="mini">查看</el-button>
                            </p>
                            <p>2021.8.21 &nbsp;<el-button type="text" size="mini">查看</el-button>
                            </p>
                        </div> -->
                        <!-- <el-upload
                            accept=".doc, .docx, .pdf" :headers="{hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}">
                        </el-upload> -->
                        <br>
                        <div style="margin-left:20px" v-for="(item,index) in orderinfo.hfCommodityAccessoryList" :key="index">
                            <i class="el-icon-document"></i>
                            <span class="textBox"><a :href='item.url'>{{item.name}}</a></span>
                        </div>

                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="形式发票:" style="width:50%;display: inline-block">
                        <!-- <span>2021.8.21</span> &nbsp;<el-button type="text" size="mini">查看</el-button> -->
                        <el-upload v-show="pic_is_show" class="avatar-uploader" style="margin-bottom: 15px;"
                            accept=".png, .jpg, .gif, .jpeg, .bmp" :action="uploadUrl" :headers="{
                            hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'
                        }" :show-file-list="false" :on-success="handleAvatarSuccess3">
                            <img v-if="orderinfo.mbOrderVO.invoice" :src="orderinfo.mbOrderVO.invoice" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="报关单据:" style="width:50%;display: inline-block">
                        <!-- <span>999</span> &nbsp;<el-button type="text" size="mini">查看</el-button> -->
                        <el-upload v-show="pic_is_show" class="avatar-uploader" style="margin-bottom: 15px;"
                            accept=".png, .jpg, .gif, .jpeg, .bmp" :action="uploadUrl" :headers="{
                            hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'
                        }" :show-file-list="false" :on-success="handleAvatarSuccess2">
                            <img v-if="orderinfo.mbOrderVO.tariffbill" :src="orderinfo.mbOrderVO.tariffbill"
                                class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>

                    </el-form-item>
                </el-form-item>
            </el-form>

        </el-dialog>

        <!--发货-->
        <el-dialog title="发货单" :visible.sync="sendformVisible" :before-close="hidesendForm" width="800px" top="5vh"
            v-dialogDrag>
            <el-form :model="formTest" :rules="formRules" ref="updateDataForm">
                <el-form-item label="运单号" prop="expressnum">
                    <el-input placeholder="请输入运单号" v-model="formTest.expressnum" clearable />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hidesendForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">保存</el-button>
            </div>
            <!-- 修改实付金额 -->
        </el-dialog>
        <el-dialog title="修改实付金额" :visible.sync="priceVisible" :before-close="priceform" width="15%" v-dialogDrag>
            <el-form :model="priceList" ref="dataForm" :rules="formRules">
                <el-form-item class="query-form-item" prop="ordertotalprice">
                    <el-input v-model="priceList.ordertotalprice" type="test" placeholder="请输入金额">
                        <!-- <template slot="append">%</template> -->
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="priceform">取消</el-button>
                <el-button type="primary" @click.native="savePrices()" :loading="formLoading">确定</el-button>
            </div>
        </el-dialog>
        <!-- 修改运费 -->
        <el-dialog title="修改运费" :visible.sync="freightVisible" :before-close="cancelFreight" width="15%" v-dialogDrag>
            <el-form :model="priceList" ref="dataForm" :rules="formRules">
                <el-form-item class="query-form-item" prop="orderfreight">
                    <el-input type="test" v-model="priceList.orderfreight" placeholder="在此输入修改后的价格">
                        <!-- <template slot="append">%</template> -->
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelFreight">取消</el-button>
                <el-button type="primary" @click.native="updateFreight()" :loading="formLoading">确定</el-button>
            </div>
        </el-dialog>

        <!--修改运单码-->
        <el-dialog title="修改运单码" :visible.sync="editOddNumbers" :before-close="cancelEditOddNumbers" width="15%" v-dialogDrag>
            <el-form :model="priceList" ref="dataForm" :rules="formRules">
                <el-form-item class="query-form-item" prop="expressnum">
                    <el-input type="test" v-model="priceList.expressnum" placeholder="在此输入运单码">
                        <!-- <template slot="append">%</template> -->
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelEditOddNumbers">取消</el-button>
                <el-button type="primary" @click.native="upodateOddNumbers()" :loading="formLoading">确定</el-button>
            </div>
        </el-dialog>



        <!-- 修改订单状态 -->
        <el-dialog title="修改状态" :visible.sync="stateVisible" :before-close="cancelState" width="15%" v-dialogDrag>
            <el-form :model="priceList" ref="dataForm" :rules="formRules">
                <el-form-item class="query-form-item" prop="orderstatus">
                    <el-select placeholder="请选择" v-model="priceList.orderstatus">
                        <el-option label="待支付" :value="0"></el-option>
                        <el-option label="已排产" :value="1"></el-option>
                        <el-option label="生产中" :value="2"></el-option>
                        <el-option label="包装中" :value="3"></el-option>
                        <el-option label="待发货" :value="4"></el-option>
                        <el-option label="待收货" :value="5"></el-option>
                        <el-option label="已完成" :value="6"></el-option>
                        <el-option label="已取消" :value="7"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelState">取消</el-button>
                <el-button type="primary" @click.native="updateState()" :loading="formLoading">确定</el-button>
            </div>
        </el-dialog>
        <!-- 修改承运公司 -->
        <el-dialog title="修改物流" :visible.sync="logisticsVisible" :before-close="cancelLogistics" width="15%"
            v-dialogDrag>

            <el-form  >
                <el-form-item class="query-form-item"  >
                    <el-select placeholder="请选择" v-model="expressionlist.expressname">
                        <el-option v-for="item in expressionlist" :key="item.expressid" :label="item.expressname"
                            :value="item.expressname">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelLogistics">取消</el-button>
                <el-button type="primary" @click.native="upodateExpression2()" :loading="formLoading">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {
        getList,
        send,
        getOrderInfo,
        getUserList,
        cancleOrder,
        nextStept,
        returnLine,
        getfontwb,
        getfontdhl,
        savePrice,
        updateState,
        expressionlist,
        upodateexpression,
        upodateoddNumbers,
        editfreight,
        updSendPicApi,
        updSendTariffbillApi,
        updSendInvoiceApi
    } from "../../api/order/saleOrder.js";
    // import { formatDateStr } from "../../filtres/index";
    import {
        BASE_URL
    } from "../../config/app";
export default {
        data() {
            var pricerule = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请输入修改后的价格"));
                } else {
                    var reg = new RegExp("^[0-9]+([.]{1}[0-9]+){0,1}$");
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(
                            new Error("请输入数字（精确到小数点后两位）")
                        );
                    }
                }
            };
            return {
                pic_is_show: true,
                uploadUrl: BASE_URL + "/upload/tool/uploadpro",
                orderworktime: "",
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                pickerOptions: {
                    shortcuts: [{
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 7
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 30
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 90
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近六个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 180
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        }
                    ]
                },
                expressionlist: [],
                cancelToggle: false,
                servetime: [],
                pushtime: "",
                // ordertime: "",
                query: {
                    compellation: "",
                    orderid: "",
                    orderstatus: "",
                    expressid: "",
                    serveid: "",
                    userid: "",
                    ordertotalprice: "",
                    systemtradeno: "",
                    startTime: "",
                    endTime: "",
                    currentPage: 1,
                    pageSize: 10
                },
                list: [],
                userList: [],
                priceList: {},
                expressInfo: {
                    trackingNumber: "",
                    trackingName: ""
                },
                expressInfos: {
                    shipmentInfo: {
                        shipperName: "",
                        shipperAccountNumber: "",
                        shipper: {
                            countryCode: "",
                            city: ""
                        },
                        consignee: {
                            countryCode: "",
                            city: ""
                        },
                        shipmentEvent: {
                            logistics: [{
                                serviceEvent: {
                                    description: "",
                                    serviceAreaCode: ""
                                },
                                data: "",
                                time: ""
                            }]
                        }
                    }
                },
                address: {},
                arrivalLocation: [],
                trackingnumber: "",
                orderinfo: {
                    // ordertime: "",
                    mbOrderVO: {
                        // ordertime: "",
                        orderpaytime: "",
                        orderschedulingtime: "",
                        orderprodutime: "",
                        orderpacktime: "",
                        orderdevlitime: "",
                        ordertacktime: "",
                        repertorysname: "",
                        systemtradeno: "",
                        orderfreight: "",
                        ordertotalprice: "",
                        orderintegral: "",
                        specsurvi: "",
                        orderleave: "",
                        expressname: "",
                        orderstatus: "",
                        compellation: "",
                        expressnum: "",
                        orderid: ""
                    },
                    mbOrderComVOList: [],
                    mbUserAddressVO: {
                        usernick: "",
                        useraddressname: "",
                        useraddressphone: "",
                        useraddress: ""
                    }
                },
                totalNumber: 0,
                loading: true,
                index: null,
                formName: null,
                formData: {
                    expressnum: ""
                },
                formExpress: false,
                formExpresss: false,
                formLoading: false,
                formInfo: false,
                sendformVisible: false,
                priceVisible: false,
                formRules: {
                    expressnum: [{
                        required: true,
                        message: "请输入运单号",
                        trigger: "blur"
                    }],
                    ordertotalprice: {
                        validator: pricerule,
                        trigger: "blur"
                    }
                },
                formTest: {
                    expressnum: "",
                    orderid: ""
                },
                multipleSelection: [], //多选集合
                freightVisible: false,
                editOddNumbers: false,
                stateVisible: false,
                logisticsVisible: false,
            };
        },
        watch: {
            orderinfo: {
                handler(n, o) {
                    console.log("======================", n)
                },
                deep: true,
            }
        },
        methods: {
            handleAvatarSuccess(res, file) {
                this.orderinfo.mbOrderVO.sendurl = res.data;
                let data = {
                    orderid: this.orderinfo.mbOrderVO.orderid,
                    sendurl: this.orderinfo.mbOrderVO.sendurl
                }
                updSendPicApi(data).then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.$message.success('发货图片修改成功！')
                }).catch((err) => {
                    this.$message.error(err.message);
                });

            },
            handleAvatarSuccess2(res, file) {
                this.orderinfo.mbOrderVO.tariffbill = res.data;
                let data = {
                    orderid: this.orderinfo.mbOrderVO.orderid,
                    tariffbill: this.orderinfo.mbOrderVO.tariffbill
                }
                updSendTariffbillApi(data).then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.$message.success('报关单据修改成功！')
                    }).catch((err) => {
                    this.$message.error(err.message);
                });
            },
            handleAvatarSuccess3(res, file) {
                this.orderinfo.mbOrderVO.invoice = res.data;
                let data = {
                    orderid: this.orderinfo.mbOrderVO.orderid,
                    invoice: this.orderinfo.mbOrderVO.invoice
                }
                updSendInvoiceApi(data)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.$message.success('发票修改成功！')
                    }).catch((err) => {
                    this.$message.error(err.message);
                });
            },
            //修改实付金额 显示表单
            editPrice() {
                this.priceVisible = true;
            },
            //修改运费
            editFreight() {
                this.freightVisible = true;
            },

            //修改运单码
            editOdd() {
                this.editOddNumbers = true;
            },

            // 修改订单状态
            editState() {
                this.stateVisible = true;
            },
            // 修改承运公司
            editLogistics() {
                this.logisticsVisible = true;
            },
            //隐藏承运公司
            cancelLogistics() {
                this.logisticsVisible = !this.logisticsVisible;
            },
            //隐藏订单状态
            cancelState() {
                this.stateVisible = !this.stateVisible;
            },
            //隐藏运费
            cancelFreight() {
                this.freightVisible = !this.freightVisible;
            },

            //隐藏运单码
            cancelEditOddNumbers() {
                this.editOddNumbers = !this.editOddNumbers;
            },
            //隐藏修改等级
            priceform() {
                this.priceVisible = !this.priceVisible;
                // this.list.usergradesort = "";
                // 刷新表单
                this.$refs["dataForm"].resetFields();
                return true;
            },
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                this.onSubmit();
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.serveid).join(); //获取所有选中行的id组成的字符串，以逗号分隔

                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
            },
            onRest() {
                this.query = {
                    currentPage: 1,
                    pageSize: 10
                };
                this.servetime = [];
                this.getList();
            },

            //隐藏物流信息
            hideExpress() {
                this.formExpress = !this.formExpress;
            },
            hideExpresss() {
                this.formExpresss = !this.formExpresss;
            },
            hideInfo() {
                // 更改值
                this.formInfo = !this.formInfo;
                // 清空表单
                return true;
            },
            onSubmit() {
                this.query.currentPage = 1;
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                // //scrollTo(0, 800);
                this.getList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },


            //修改运单号
            upodateOddNumbers() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let params = {
                            expressnum: this.priceList.expressnum,
                            orderid: this.priceList.orderid
                        };
                        if(params.expressnum==null){
                          return false
                        }
                     //   upodateoddNumbers(new URLSearchParams(params)).then(response => {
                        upodateoddNumbers(params).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }

                            this.$message.success("修改成功");
                            this.editOddNumbers = false;
                            this.orderinfo.mbOrderVO.expressnum = this.priceList.expressnum;
                            // // 加载表格数据
                            this.getList();
                        });
                    }
                });
            },
            //修改运费
            updateFreight() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let params = {
                            orderfreight: this.priceList.orderfreight,
                            orderid: this.priceList.orderid
                        };
                        editfreight(params).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }

                            this.$message.success("修改成功");
                            this.freightVisible = false;
                            this.orderinfo.mbOrderVO.orderfreight = this.priceList.orderfreight;
                            // // 加载表格数据
                            this.getList();
                        });
                    }
                });
            },


            //修改承运公司
            upodateExpression2() {
                if (this.expressionlist.expressname){
                    let params = {
                        expressname: this.expressionlist.expressname,
                        orderid: this.priceList.orderid
                    };
                    console.log('param=',params)
                    upodateexpression(params).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }

                        this.$message.success("修改成功");
                        this.logisticsVisible = false;
                        this.orderinfo.mbOrderVO.expressname = this.expressionlist.expressname;
                        // // 加载表格数据
                        this.getList();
                    });
                }



                // this.$refs["dataForm"].validate(valid => {
                //     if (valid) {
                //
                //     }
                // });
            },

            updateState() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let params = {
                            orderstatus: this.priceList.orderstatus,
                            orderid: this.priceList.orderid
                        };
                        updateState(params).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }

                            this.$message.success("修改成功");
                            this.stateVisible = false;
                            this.orderinfo.mbOrderVO.orderstatus = this.priceList.orderstatus;
                            // // 加载表格数据
                            this.getList();
                        });
                    }
                });
            },

            //保存实付金额
            savePrices() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let params = {
                            ordertotalprice: this.priceList.ordertotalprice,
                            orderid: this.priceList.orderid
                        };
                        console.log('params',params);
                        savePrice(params).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }

                            this.$message.success("修改成功");
                            this.priceVisible = false;
                            this.orderinfo.mbOrderVO.ordertotalprice = this.priceList.ordertotalprice;
                            // // 加载表格数据
                            this.getList();
                        });
                    }
                });
            },
            //保存运费
            /*  saveFreight() {
                  this.freightVisible = false;
              },*/
            //保存订单状态
            saveState() {
                this.stateVisible = false;
            },
            //保存承运公司
            saveLogistics() {
                this.logisticsVisible = false;
            },
            getList() {
                this.loading = true;
                console.log(this.query)
                getList(this.query)
                    .then(response => {
                        console.log(response)
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.list = response.data.list || [];
                        this.totalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            expressionList() {
                this.loading = true;
                expressionlist().then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return
                    }
                    this.expressionlist = response.data || [];
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                }).catch(() => {
                    this.loading = false;
                    this.expressionlist = [];
                });
            },

            getUserList() {
                getUserList()
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.userList = response.data || [];
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            handleInfo(index, row) {
                this.loading = true;
                this.orderinfo = "";
                this.query.orderid = row.orderid;
                getOrderInfo(this.query).then(response => {
                    console.log('订单详情',response.data)
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.orderinfo = response.data || [];
                    this.priceList = this.orderinfo.mbOrderVO;
                    this.query.orderid = "";
                    this.formInfo = true;
                    this.loading = false;
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                }).catch(() => {
                    this.loading = false;
                });
            },

            hidesendForm() {
                // 更改值
                this.sendformVisible = !this.sendformVisible;
                this.formTest.orderid = "";
                this.formTest.expressnum = "";
                return true;
            },

            //取消订单
            cancleOrder(row) {
                if (row) {
                    this.$confirm("确认要取消订单吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.query.orderid = row.orderid;
                            cancleOrder(this.query)
                                .then(response => {
                                    if (response.code) {
                                        this.$message.error(response.message);
                                    }
                                    this.$message.success("操作成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.getList();
                                    this.formInfo = false;
                                    setTimeout(() => {
                                        this.loading = false;
                                    }, 0.3 * 1000);
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        }).catch((err) => {
                    this.$message.error(err.message);
                });
                }
            },
            //下一步
            nextStept(row) {
                if (row) {
                    this.$confirm("确认要进行下一步吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.query.orderid = row.orderid;
                            this.query.orderstatus = row.orderstatus;
                            this.loading = true;
                            nextStept(this.query)
                                .then(response => {
                                    if (response.code) {
                                        this.$message.error(response.message);
                                    }
                                    this.$message.success("操作成功");
                                    this.loading = false;
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.query.orderstatus = "";
                                    this.getList();
                                    setTimeout(() => {
                                        this.loading = false;
                                    }, 0.3 * 1000);
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        });
                }
            },
            //发货
            send(row) {
                if ((row.orderphysicaltype == 0) | (row.orderphysicaltype == 3)) {
                    this.sendformVisible = false;
                    send(this.formTest)
                        .then(response => {
                            if (response.code) {
                                this.$message.error(response.message);
                            }
                            this.$message.success("操作成功");
                            // 刷新数据
                            //this.list.splice(index, 1);
                            this.sendformVisible = false;

                            this.getList();
                            setTimeout(() => {
                                this.loading = false;
                            }, 0.3 * 1000);
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else {
                    this.sendformVisible = true;
                }
                this.formTest.orderid = row.orderid;
            },
            formSubmit() {
                this.$refs["updateDataForm"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        send(this.formTest)
                            .then(response => {
                                if (response.code) {
                                    this.$message.error(response.message);
                                }
                                this.$message.success("操作成功");
                                // 刷新数据
                                //this.list.splice(index, 1);
                                this.sendformVisible = false;

                                this.getList();
                                setTimeout(() => {
                                    this.loading = false;
                                }, 0.3 * 1000);
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    }
                });
            },
            //归还额度
            returnLine(row) {
                if (row) {
                    this.$confirm("确认要归还吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.query.orderid = row.orderid;
                            this.query.userid = row.userid;
                            this.query.ordertotalprice = row.ordertotalprice;
                            returnLine(this.query)
                                .then(response => {
                                    if (response.code) {
                                        this.$message.error(response.message);
                                    }
                                    this.$message.success("操作成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.getList();
                                    setTimeout(() => {
                                        this.loading = false;
                                    }, 0.3 * 1000);
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        });
                }
            },

            //  expressMessagess(){

            //     this.$message.error("Please contact specific customer service specialist for instant logistics status");
            //  },

            //显示物流信息
            expressMessage(row) {
                this.loading = true;
                let params = new URLSearchParams();
                params.append("trackingnumber", row.expressnum);
                if (row.orderphysicaltype == 1) {
                    getfontwb(params).then(res => {
                        this.expressInfo = res.data;
                        this.loading = false;
                        this.formExpress = true;
                    }).catch((err) => {
                    this.$message.error(err.message);
                });
                } else {
                    getfontdhl(params).then(res => {
                        this.expressInfos = res.data;
                        this.loading = false;
                        this.formExpresss = true;
                    }).catch((err) => {
                    this.$message.error(err.message);
                    });
                }

                //   alert("物流信息")
            },
            //导出
            exportExcel() {
                window.location.href = BASE_URL + "/orderManage/export";
            },
            exportOrderDetailExcel() {
                // console.log(this.orderinfo.mbOrderVO.orderid);
                window.location.href =
                    BASE_URL +
                    "/orderManage/exportOrderDetail?orderid=" +
                    this.orderinfo.mbOrderVO.orderid;
            }
        },
        filters: {
            price: function (myInput) {
                if (myInput != null) {
                    var val = parseInt(myInput);
                    if (typeof val === "number") {
                        return parseFloat(myInput).toFixed(2);
                    }
                } else {
                    return "-";
                }
            },
            orderphysicaltypeFilter(item) {
                let text = "-";
                item = Number(item)
                switch (item) {
                    case 1:
                        text = "联邦快递"
                        break;
                    case 2:
                        text = "DHL物流"
                        break;
                    case 3:
                        text = "自提"
                        break;
                    default:
                        text = "-"
                }
                return text
            }
        },
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.getList();
            //专属客服
            this.getUserList();
            //承运公司
            this.expressionList();
        }
    };
</script>

<style type="text/scss" lang="scss">
    body {
    margin: 0;
}
    .playorder{
        width: 100px;
        height: auto;
        border-radius: 5px;
    }
</style>
